
const setCustomVw = function (): void {
  const vw = document.body.clientWidth / 100;
  document.body.style.setProperty('--vw', `${vw}px`);
}
export default setCustomVw;
